import { Component, Input, OnInit } from '@angular/core';
import { CardAnimatedItem } from '../card-animated/card-animated.component';

@Component({
    selector: 'app-cards-grid',
    standalone: false,
    templateUrl: './cards-grid.component.html',
    styleUrl: './cards-grid.component.scss'
})
export class CardsGridComponent {
    @Input() items: CardAnimatedItem[] = [];

    /** Cuando true, si hay 1 card la estira/centra. En otros módulos queda en false. */
    @Input() stretchSingle = false;

    get hasSingleCard(): boolean {
        const valid = (this.items ?? []).filter((i) => (i?.title?.trim()?.length ?? 0) > 0 || (Array.isArray(i?.routerLink) ? i.routerLink.length > 0 : !!i?.routerLink));
        return valid.length === 1;
    }

    /** solo aplica el layout especial si stretchSingle=true */
    get singleLayoutEnabled(): boolean {
        return this.stretchSingle && this.hasSingleCard;
    }
}
